<div class="backstretch" style="padding-top: 50px">
    <div class="container-fluid">
        <div class="login-box text-center" style="padding: 50px 0; margin: 0 auto; position: relative">
            @if (!authService.username) {
                <img alt="logo" src="assets/images/pfjpeg.jpg" style="max-height: 64px" />
            }
            <div class="logo">
                @switch (page) {
                    @case ("404") {
                        <span>404 Not Found</span>
                    }
                    @case ("500") {
                        <span>Unknown Error</span>
                    }
                    @case ("invalid") {
                        <span>Invalid Input</span>
                    }
                    @case ("instancenotfound") {
                        <span>Unknown Instance</span>
                    }
                    @default {
                        <span>Unknown Error</span>
                    }
                }
            </div>
            <div class="login-form-1">
                <form class="text-left">
                    <div style="margin-left: 20px"></div>
                    <div class="main-login-form">
                        <br />
                        <div>
                            @switch (page) {
                                @case ("404") {
                                    <app-error-404></app-error-404>
                                }
                                @case ("500") {
                                    <app-error-500></app-error-500>
                                }
                                @case ("invalid") {
                                    <app-error-invalid></app-error-invalid>
                                }
                                @case ("instancenotfound") {
                                    <app-error-instance-not-found></app-error-instance-not-found>
                                }
                                @default {
                                    <div>An unknown error occurred.</div>
                                }
                            }
                        </div>
                        <div>&nbsp;</div>
                        <div class="text-center">
                            @if (page !== "instancenotfound") {
                                <button class="btn btn-default" (click)="back()">Go back</button>
                            }
                        </div>
                        <div>&nbsp;</div>
                        <div style="white-space: nowrap">
                            If you continue having trouble, contact Sedona Support at:
                            <ul style="margin-left: 20px">
                                <li><a href="{{ infoService.supportInfo['url'] }}" target="_blank">ST Portal</a></li>
                                <li>
                                    <a href="tel:{{ infoService.supportInfo['phone'] }}">{{
                                        infoService.supportInfo["phone"]
                                    }}</a>
                                </li>
                                <li>
                                    <a href="mailto:{{ infoService.supportInfo['email'] }}">{{
                                        infoService.supportInfo["email"]
                                    }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="disable-select login-copyright">
        Copyright &copy; {{ curYear }}<br />
        <img
            title="Sedona Technologies"
            alt="Sedona Technologies"
            src="assets/images/sedonawhitefancy.png"
            class="disable-select login-copyright-logo" />
    </div>
</div>
